<script setup lang="ts">
import {NuxtLink} from "#components"

const props = defineProps<{
  icon: string
  active?: boolean,
  to?: string,
  href?: string,
  activeStyle?: string,
  withNotificationPill?: boolean
}>()

const cl = computed(() => {
  const s = 'cursor-pointer select-none inline-flex justify-center items-center min-w-button p-5 rounded-bento bg-white active:text-white active:bg-domain transition outline-none focus-visible:ring-2 focus-visible:ring-domain'
  return [s, props.active ? props.activeStyle ?? '!bg-domain text-white' : 'text-domain-dark hover:text-domain']
})
</script>

<template>
  <component :is="to ? NuxtLink : 'a'" :to="to" :href="href" :class="cl" class="relative">
    <span class="material-icons-outlined">{{ icon }}</span>
    <AtomsNotificationPill v-if="withNotificationPill" class="absolute" />
  </component>
</template>